import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section
      aria-hidden="true"
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#E4DBD0] bg-[#F4EFE6] py-6"
    >
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center">
            <span className="font-serif-display whitespace-nowrap px-8 text-2xl italic text-[#63584E] md:text-3xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#C4623C]" />
          </span>
        ))}
      </div>
    </section>
  );
};
